import type {BioIconProps} from './common-types'

export function DiscountThunderIcon({fill, ...attributes}: BioIconProps) {
  return (
    <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1794 0.329126C10.4304 0.469079 10.5536 0.762189 10.478 1.03947L8.81829 7.12502H14.875C15.1239 7.12502 15.349 7.27267 15.4482 7.50093C15.5474 7.72918 15.5017 7.99453 15.3319 8.17647L6.58192 17.5515C6.38582 17.7616 6.0717 17.8109 5.82067 17.6709C5.56964 17.531 5.44641 17.2379 5.52204 16.9606L7.18173 10.875H1.12501C0.876141 10.875 0.650985 10.7274 0.551797 10.4991C0.452609 10.2709 0.498294 10.0055 0.668104 9.82357L9.4181 0.448572C9.61421 0.238461 9.92832 0.189174 10.1794 0.329126Z"
        fill="#DC2626"
      />
    </svg>
  )
}
